(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
if (!window.location.pathname.includes('/tools/bundle-subscriptions/bundle')){
  const authData = localStorage.getItem("awtomicApiAuth");

  if (authData) {
    try {
      const parsed = JSON.parse(authData);

      // Select your header login button
      const loginBtn = document.querySelector(
        ".header__icon--account"
      );

      if (loginBtn && parsed.customerId) {
        if (parsed.customerId !== "") {
          // Logged in → Change button to "Account"
          loginBtn.textContent = "Account";
          loginBtn.setAttribute("href", "/tools/bundle-subscriptions"); // or your Awtomic account page
        } else {
          // Logged out → Change button to "Sign In"
          loginBtn.textContent = "Login";
          loginBtn.setAttribute("href", "/tools/bundle-subscriptions"); // or your login page
        }
      }
    } catch (e) {
      console.error("Error parsing Awtomic auth data:", e);
    }
  }
}     
})

document.body.addEventListener('click', async (event) => {
  const cart_btn = event.target.closest('#cart-icon-bubble');
  if (!cart_btn) return; // not the cart button, ignore

  await checkSubscriptionBoxOccurrences();
});

class StickyHeader extends HTMLElement {
constructor() {
super();
}
connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');
this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
this.createObserver();
}
disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}
createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});
observer.observe(this.header);
}
onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
// if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);
requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <=this.headerBounds.top) { requestAnimationFrame(this.reset.bind(this)); } this.currentScrollTop=scrollTop; } hide() { this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); } reveal() { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); } reset() { this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); } closeMenuDisclosure() { this.disclosures=this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(disclosure=> disclosure.close());
}
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
